/**
 * Feature flag and env helpers for provider acquisition popups.
 */

export const PROVIDER_ACQUISITION_POPUPS_ENV = 'PROVIDER_ACQUISITION_POPUPS_ENABLED';
export const VITE_PROVIDER_ACQUISITION_POPUPS_ENV = 'VITE_PROVIDER_ACQUISITION_POPUPS_ENABLED';

export function isProviderAcquisitionPopupsEnabled(
  env: Record<string, string | undefined> = process.env,
): boolean {
  return env[PROVIDER_ACQUISITION_POPUPS_ENV] === 'true';
}

const getImportMetaEnv = (): Record<string, string | undefined> | undefined => {
  return (globalThis as { import?: { meta?: { env?: Record<string, string | undefined> } } }).import?.meta
    ?.env;
};

export function isProviderAcquisitionPopupsEnabledClient(): boolean {
  if (typeof window === 'undefined') {
    return process.env[VITE_PROVIDER_ACQUISITION_POPUPS_ENV] === 'true';
  }
  const env = getImportMetaEnv();
  return env?.[VITE_PROVIDER_ACQUISITION_POPUPS_ENV] === 'true';
}
